class Slider {
  constructor(sliderElement) {
    this.slider = sliderElement;
    this.prevButton = this.slider.querySelector(".slider-button_prev");
    this.nextButton = this.slider.querySelector(".slider-button_next");
    this.container = this.slider.querySelector(".slider__container");
    this.items = this.slider.querySelectorAll(".slider__item");
    this.itemsToShow = 3;
    this.currentIndex = 0;

    this.setGap();
    this.itemWidth = this.items[0].offsetWidth + this.gap;
    this.totalItems = this.items.length;

    this.updateButtons();
    this.addEventListeners();
    this.showSlide(this.currentIndex);
  }

  setGap() {
    if (document.documentElement.clientWidth < 1440) {
      this.gap = 24;
    } else {
      this.gap = 30;
    }
    this.container.style.gap = `${this.gap}px`;
  }

  addEventListeners() {
    this.prevButton.addEventListener("click", () => {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.showSlide(this.currentIndex);
      }
    });

    this.nextButton.addEventListener("click", () => {
      if (this.currentIndex < this.totalItems - this.itemsToShow) {
        this.currentIndex++;
        this.showSlide(this.currentIndex);
      }
    });

    window.addEventListener("resize", () => {
      this.setGap();
      this.itemWidth = this.items[0].offsetWidth + this.gap;
      this.showSlide(this.currentIndex);
    });
  }

  updateButtons() {
    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled =
      this.currentIndex >= this.totalItems - this.itemsToShow;
  }

  showSlide(index) {
    const offset = index * (this.items[0].offsetWidth + this.gap);
    this.container.style.transform = `translateX(-${offset}px)`;
    this.updateButtons();
  }
}

const sliders = document.querySelectorAll(".slider");
sliders.forEach((sliderElement) => {
  new Slider(sliderElement);
});
